var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, indent, no-undef, no-var, object-curly-spacing, react/forbid-prop-types, react/jsx-closing-bracket-location, react/jsx-indent-props, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var ApiOptions = require("../../perseus-api.jsx").Options;
var BaseRadio = require("./base-radio.jsx");
var Changeable = require("../../mixins/changeable.jsx");
var Editor = require("../../editor.jsx");

var _require = require("../../icon-paths.js"),
    iconPlus = _require.iconPlus,
    iconTrash = _require.iconTrash;

var InlineIcon = require("../../components/inline-icon.jsx");
var PropCheckBox = require("../../components/prop-check-box.jsx");

var ChoiceEditor = React.createClass({
    displayName: "ChoiceEditor",

    propTypes: {
        apiOptions: ApiOptions.propTypes,

        choice: React.PropTypes.object,
        showDelete: React.PropTypes.bool,
        onClueChange: React.PropTypes.func,
        onContentChange: React.PropTypes.func,
        onDelete: React.PropTypes.func
    },

    render: function render() {
        var checkedClass = this.props.choice.correct ? "correct" : "incorrect";
        var placeholder = "Type a choice here...";

        if (this.props.choice.isNoneOfTheAbove) {
            placeholder = this.props.choice.correct ? "Type the answer to reveal to the user..." : "None of the above";
        }

        var editor = React.createElement(Editor, {
            ref: "content-editor",
            apiOptions: this.props.apiOptions,
            content: this.props.choice.content || "",
            widgetEnabled: false,
            placeholder: placeholder,
            disabled: this.props.choice.isNoneOfTheAbove && !this.props.choice.correct,
            onChange: this.props.onContentChange
        });

        var clueEditor = React.createElement(Editor, {
            ref: "clue-editor",
            apiOptions: this.props.apiOptions,
            content: this.props.choice.clue || "",
            widgetEnabled: false,
            placeholder: i18n._("Why is this choice " + checkedClass + "?"),
            onChange: this.props.onClueChange
        });

        var deleteLink = React.createElement(
            "a",
            {
                className: "simple-button orange delete-choice",
                href: "#",
                onClick: this.props.onDelete,
                title: "Remove this choice"
            },
            React.createElement(InlineIcon, iconTrash)
        );

        return React.createElement(
            "div",
            { className: "choice-clue-editors" },
            React.createElement(
                "div",
                { className: "choice-editor " + checkedClass },
                editor
            ),
            React.createElement(
                "div",
                { className: "clue-editor" },
                clueEditor
            ),
            this.props.showDelete && deleteLink
        );
    }
});

var RadioEditor = React.createClass({
    displayName: "RadioEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        apiOptions: ApiOptions.propTypes,
        choices: React.PropTypes.arrayOf(React.PropTypes.shape({
            content: React.PropTypes.string,
            clue: React.PropTypes.string,
            correct: React.PropTypes.bool
        })),
        displayCount: React.PropTypes.number,
        randomize: React.PropTypes.bool,
        hasNoneOfTheAbove: React.PropTypes.bool,
        multipleSelect: React.PropTypes.bool,
        countChoices: React.PropTypes.bool,

        // TODO(kevinb): DEPRECATED: This is be used to force deselectEnabled
        // behavior on mobile but not on desktop.  When enabled, the user can
        // deselect a radio input by tapping on it again.
        deselectEnabled: React.PropTypes.bool,

        static: React.PropTypes.bool
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            choices: [{}, {}],
            displayCount: null,
            randomize: false,
            hasNoneOfTheAbove: false,
            multipleSelect: false,
            countChoices: false,
            deselectEnabled: false
        };
    },

    render: function render() {
        var numCorrect = _.reduce(this.props.choices, function (memo, choice) {
            return choice.correct ? memo + 1 : memo;
        }, 0);
        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(
                    "a",
                    {
                        href: "https://docs.google.com/document/d/1frZf7yrWVWb1n4tVjqlzqVUiv1pn4cZXbxgP62-JDBY/edit#heading=h.8ng1isya19nu",
                        target: "_blank"
                    },
                    "Multiple choice style guide"
                ),
                React.createElement("br", null),
                React.createElement(
                    "div",
                    { className: "perseus-widget-left-col" },
                    React.createElement(PropCheckBox, {
                        label: "Multiple selections",
                        labelAlignment: "right",
                        multipleSelect: this.props.multipleSelect,
                        onChange: this.onMultipleSelectChange
                    })
                ),
                React.createElement(
                    "div",
                    { className: "perseus-widget-right-col" },
                    React.createElement(PropCheckBox, {
                        label: "Randomize order",
                        labelAlignment: "right",
                        randomize: this.props.randomize,
                        onChange: this.props.onChange
                    })
                ),
                this.props.multipleSelect && React.createElement(
                    "div",
                    { className: "perseus-widget-left-col" },
                    React.createElement(PropCheckBox, {
                        label: "Specify number correct",
                        labelAlignment: "right",
                        countChoices: this.props.countChoices,
                        onChange: this.onCountChoicesChange
                    })
                )
            ),
            React.createElement(BaseRadio, {
                ref: "baseRadio",
                multipleSelect: this.props.multipleSelect,
                countChoices: this.props.countChoices,
                numCorrect: numCorrect,
                editMode: true,
                labelWrap: false,
                apiOptions: this.props.apiOptions,
                choices: this.props.choices.map(function (choice, i) {
                    var _this = this;

                    return {
                        content: React.createElement(ChoiceEditor, {
                            ref: "choice-editor" + i,
                            apiOptions: this.props.apiOptions,
                            choice: choice,
                            onContentChange: function onContentChange(newProps) {
                                if ("content" in newProps) {
                                    _this.onContentChange(i, newProps.content);
                                }
                            },
                            onClueChange: function onClueChange(newProps) {
                                if ("content" in newProps) {
                                    _this.onClueChange(i, newProps.content);
                                }
                            },
                            onDelete: this.onDelete.bind(this, i),
                            showDelete: this.props.choices.length >= 2
                        }),
                        isNoneOfTheAbove: choice.isNoneOfTheAbove,
                        checked: choice.correct
                    };
                }, this),
                onChange: this.onChange
            }),
            React.createElement(
                "div",
                { className: "add-choice-container" },
                React.createElement(
                    "a",
                    {
                        className: "simple-button orange",
                        href: "#",
                        onClick: this.addChoice.bind(this, false)
                    },
                    React.createElement(InlineIcon, iconPlus),
                    " Add a choice",
                    " "
                ),
                !this.props.hasNoneOfTheAbove && React.createElement(
                    "a",
                    {
                        className: "simple-button",
                        href: "#",
                        onClick: this.addChoice.bind(this, true)
                    },
                    React.createElement(InlineIcon, iconPlus),
                    " None of the above",
                    " "
                )
            )
        );
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    onMultipleSelectChange: function onMultipleSelectChange(allowMultiple) {
        allowMultiple = allowMultiple.multipleSelect;

        var numCorrect = _.reduce(this.props.choices, function (memo, choice) {
            return choice.correct ? memo + 1 : memo;
        }, 0);

        if (!allowMultiple && numCorrect > 1) {
            var choices = _.map(this.props.choices, function (choice) {
                return _.defaults({
                    correct: false
                }, choice);
            });
            this.props.onChange({
                multipleSelect: allowMultiple,
                choices: choices
            });
        } else {
            this.props.onChange({
                multipleSelect: allowMultiple
            });
        }
    },

    onCountChoicesChange: function onCountChoicesChange(count) {
        count = count.countChoices;
        this.props.onChange({ countChoices: count });
    },

    onChange: function onChange(_ref) {
        var checked = _ref.checked;

        var choices = _.map(this.props.choices, function (choice, i) {
            return _.extend({}, choice, {
                correct: checked[i],
                content: choice.isNoneOfTheAbove && !checked[i] ? "" : choice.content
            });
        });

        this.props.onChange({ choices: choices });
    },

    onContentChange: function onContentChange(choiceIndex, newContent) {
        var choices = this.props.choices.slice();
        choices[choiceIndex] = _.extend({}, choices[choiceIndex], {
            content: newContent
        });
        this.props.onChange({ choices: choices });
    },

    onClueChange: function onClueChange(choiceIndex, newClue) {
        var choices = this.props.choices.slice();
        choices[choiceIndex] = _.extend({}, choices[choiceIndex], {
            clue: newClue
        });
        if (newClue === "") {
            delete choices[choiceIndex].clue;
        }
        this.props.onChange({ choices: choices });
    },

    onDelete: function onDelete(choiceIndex, e) {
        e.preventDefault();

        var choices = this.props.choices.slice();
        var deleted = choices[choiceIndex];

        choices.splice(choiceIndex, 1);

        this.props.onChange({
            choices: choices,
            hasNoneOfTheAbove: this.props.hasNoneOfTheAbove && !deleted.isNoneOfTheAbove
        });
    },

    addChoice: function addChoice(noneOfTheAbove, e) {
        var _this2 = this;

        e.preventDefault();

        var choices = this.props.choices.slice();
        var newChoice = { isNoneOfTheAbove: noneOfTheAbove };
        var addIndex = choices.length - (this.props.hasNoneOfTheAbove ? 1 : 0);

        choices.splice(addIndex, 0, newChoice);

        this.props.onChange({
            choices: choices,
            hasNoneOfTheAbove: noneOfTheAbove || this.props.hasNoneOfTheAbove
        }, function () {
            _this2.refs["choice-editor" + addIndex].refs["content-editor"].focus();
        });
    },

    setDisplayCount: function setDisplayCount(num) {
        this.props.onChange({ displayCount: num });
    },

    focus: function focus() {
        this.refs["choice-editor0"].refs["content-editor"].focus();
        return true;
    },

    getSaveWarnings: function getSaveWarnings() {
        if (!_.some(_.pluck(this.props.choices, "correct"))) {
            return ["No choice is marked as correct."];
        }
        return [];
    },

    serialize: function serialize() {
        return _.pick(this.props, "choices", "randomize", "multipleSelect", "countChoices", "displayCount", "hasNoneOfTheAbove", "deselectEnabled");
    }
});

module.exports = RadioEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/radio/editor.jsx
 ** module id = 75
 ** module chunks = 0 2
 **/